<div class="bodycontainer">
  <div id="loader" *ngIf="loading"></div> 
  <h1 *ngIf="!isLoggedIn">Formulaire d'inscription</h1> 
  <form  [formGroup]="signupForm"*ngIf="!isLoggedIn">

    <fieldset >
      <div style="display: flex;">
        <label>
          <div *ngIf="submitted && f.usertype.errors" class="invalid">
          <div *ngIf="f.usertype.errors.required">Type Utilisateur est obligatoire</div>
      </div>Type Utilisateur:
      <select  class="input-field"  placeholder="Entrer Votre Role Utilisateur"id="role" formControlName="usertype" name="usertype"
      [ngClass]="{ 'is-invalid': submitted && f.usertype.errors }" >
      <option value="Clientpor">Client Porteur</option>
      <option value="Clientcomm">Client commerçant</option>
      </select>
    </label>
      <label><div *ngIf="submitted && f.lastname.errors" class="invalid">
        <div *ngIf="f.lastname.errors.required">Nom Obligatoire</div>
    </div><span>Nom Utilisateur:
      <input class="input-field" type="text" placeholder="Entrer Votre Nom" id="lastname" formControlName="lastname" name="lastname" [ngClass]="{ 'is-invalid': submitted && f.lastname.errors }"></span>
</label>
  
      <label><div *ngIf="submitted && f.firstname.errors" class="invalid">
        <div *ngIf="f.firstname.errors.required">Prénom Obligatoire</div>
    </div><span>Prénom Utilisateur:
      <input class="input-field" type="text" placeholder="Entrer Votre Prenom" id="firstname" formControlName="firstname" name="firstname" [ngClass]="{ 'is-invalid': submitted && f.firstname.errors }"></span>
  </label>
      </div>


  <label style="max-width: 50%;"><div *ngIf="submitted && f.clientcode.errors" class="invalid">
    <div *ngIf="f.clientcode.errors.required">Veuillez générer votre code client</div>
</div>Code Client:<div style="display: flex;"><input class="input-field" style="background-color: white;color:black" type="text" id="clientcode" [ngClass]="{ 'is-invalid': submitted && f.clientcode.errors }"formControlName="clientcode" readonly="true"></div></label>
  
 <!--<label><div style="display: flex;"><span style="flex: 0.5">Indicatif:</span><span style="flex: 1">Mobile:</span><span style="flex:1">Confirmer mobile:</span></div>
    <div style="display: flex;"><div *ngIf="submitted && f.indicatif.errors" style="flex: 0.5" class="invalid">
    <div *ngIf="f.indicatif.errors.required">Indicatif Mobile Obligatoire </div>
    <div *ngIf="f.indicatif.errors.pattern">Veuillez saisir un indicatif valide</div> 
</div>
<div *ngIf="submitted && f.mobile.errors" style="flex:1"class="invalid">
  <div *ngIf="f.mobile.errors.required">Numéro Mobile Obligatoire</div>
  <div *ngIf="f.mobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
</div>
<div *ngIf="submitted && f.confirmmobile.errors" class="invalid">
<div *ngIf="f.confirmmobile.errors.required">Numéro Mobile Obligatoire</div>
<div *ngIf="f.confirmmobile.errors.mustMatch">Les numéros mobiles ne sont pas identiques</div>
<div *ngIf="f.confirmmobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>

</div> 
</div>
<div style="display: flex"><input class="input-field" style="flex: 0.5"type="text" placeholder="Indicatif pays" id="indicatif" 
[ngClass]="{ 'is-invalid': submitted && f.indicatif.errors }"formControlName="indicatif" style="width: 100px;">
<input class="input-field" style="flex:1"type="text" placeholder="Numéro Mobile" id="mobile" 
[ngClass]="{ 'is-invalid': submitted && f.mobile.errors }"formControlName="mobile"> 
<input class="input-field" style="flex:1"type="text" placeholder="Confirmez Mobile" id="confirmmobile" 
[ngClass]="{ 'is-invalid': submitted && f.confirmmobile.errors }"formControlName="confirmmobile">
</div> 
</label>--> 

<label><div style="display: flex;"><span style="flex: 1">Email:</span><span style="flex: 1">Confirmer Email:</span></div>
<div style="display: flex;"><div *ngIf="submitted && f.email.errors" class="invalid"style="flex: 1">
  <div *ngIf="f.email.errors.required">Email Obligatoire</div>
  <div *ngIf="f.email.errors.email">Adresse Email non valides</div>
</div>
<div *ngIf="submitted && f.confirmemail.errors" class="invalid"style="flex: 1">
<div *ngIf="f.confirmemail.errors.required">Email Obligatoire</div>
<div *ngIf="f.confirmemail.errors.email">Adresse Email non valides</div>
<div *ngIf="f.confirmemail.errors.mustMatch">Les Emails  ne sont pas identiques</div>
</div></div>
<div style="display: flex"><input class="input-field" type="email" placeholder="Entrez Votre Email" id="email" 
[ngClass]="{ 'is-invalid': submitted && f.email.errors }"formControlName="email">
<input class="input-field" type="email" placeholder="Confirmez Votre Email" id="confirmemail" 
[ngClass]="{ 'is-invalid': submitted && f.confirmemail.errors }"formControlName="confirmemail" required></div>
</label>

<label><div style="display: flex;"><span style="flex: 1">Mot de passe:</span><span style="flex: 1">Confirmer Mot de passe:</span></div>
<div style="display: flex;"> <div *ngIf="submitted && f.password.errors" class="invalid"style="flex: 1">
  <div *ngIf="f.password.errors.required">Mot de passe Obligatoire</div> 
</div>
<div *ngIf="submitted && f.confirmpassword.errors" class="invalid"style="flex: 1">
<div *ngIf="f.confirmpassword.errors.required">Mot de passe Obligatoire</div>
<div *ngIf="f.confirmpassword.errors.mustMatch">Les Mot de passe  ne sont pas identiques</div>
</div></div>
<div style="display: flex">
<input class="input-field" [type]="fieldTextType ? 'text' : 'password'" placeholder="Entrez Votre Mot De Passe" id="password" 
[ngClass]="{ 'is-invalid': submitted && f.password.errors }"formControlName="password" required>
<span class="input-field">
  <i
    class="fa"
    [ngClass]="{
      'fa-eye-slash': !fieldTextType,
      'fa-eye': fieldTextType
    }"
    (click)="toggleFieldTextType()"
  ></i>
</span>
<input class="input-field" [type]="repeatFieldTextType ? 'text' : 'password'" placeholder="Confirmer Votre Mot De Passe" id="confirmpassword" 
[ngClass]="{ 'is-invalid': submitted && f.confirmpassword.errors }"formControlName="confirmpassword" required>
<span class="input-field">
  <i
    class="fa"
    [ngClass]="{
      'fa-eye-slash': !repeatFieldTextType,
      'fa-eye': repeatFieldTextType
    }"
    (click)="togglerepeatFieldTextType()"
  ></i>
</span>
</div>
</label>
    </fieldset>
    <button class="btn btn-success" (click)="onSignup()">Inscription</button>
    <button class="btn btn-primary" (click)="onReset()">Réinitialiser</button>    
  </form>
  <div class="container-fluid" *ngIf="!loading && role"> 
  <h1 *ngIf="role == 'superadmin'||role == 'adminbanque'||role == 'userbanque'">Formulaire d'ajout des utilisateurs</h1>
  <p>Merci de remplir le formulaire avec les informations obligatoires</p>
  <form [formGroup]="signupFormsuperadmin"*ngIf="role == 'superadmin'">
    <fieldset>
      <div style="display: flex;">
        <label>
          <div *ngIf="submitted && fsuperadmin.responsable.errors" class="invalid">
          <div *ngIf="fsuperadmin.responsable.errors.required">Type Utilisateur est obligatoire</div>
      </div>
      Responsable:<select  class="input-field"  placeholder="Entrer Votre Role Utilisateur"id="role" formControlName="responsable" name="responsable"
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.responsable.errors }" >
      <option value="user">Profil banque</option>
      <option value="comite">Profil Président Comite arbitrage</option>
      </select>
    </label>
    <!--
              <label *ngIf="signupFormsuperadmin.get('responsable').value=='user'">
          <div *ngIf="submitted && fsuperadmin.role.errors" class="invalid">
          <div *ngIf="fsuperadmin.role.errors.required">Role Utilisateur est obligatoire</div>
      </div>Role Utilisateur:
      <select  class="input-field"  placeholder="Entrer Votre Role Utilisateur"id="role" formControlName="role" name="role"
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.role.errors }" >
      <option value="adminbanque">Admin banque</option>
      <option value="userbanque">Utilisateur banque</option>
      <option value="Metier">Métier</option>
      <option value="Agence">Agence</option>
      <option value="comite arbitrage">Comite Arbitrage</option>
      <option disabled value="Candidat">Candidat</option>
            </select>
    </label>
    -->  
        <label>
          <div *ngIf="submitted && fsuperadmin.lastname.errors" class="invalid">
          <div *ngIf="fsuperadmin.lastname.errors.required">Nom Obligatoire</div>
      </div><span>Nom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Nom" id="lastname" formControlName="lastname" name="lastname" [ngClass]="{ 'is-invalid': submitted && fsuperadmin.lastname.errors }"></span>
  </label>
    
        <label>
          <div *ngIf="submitted && fsuperadmin.firstname.errors" class="invalid">
          <div *ngIf="fsuperadmin.firstname.errors.required">Prénom Obligatoire</div>
      </div><span>Prénom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Prenom" id="firstname" formControlName="firstname" name="firstname" [ngClass]="{ 'is-invalid': submitted && fsuperadmin.firstname.errors }"></span>
    </label>
        </div>
      <label for=""*ngIf="signupFormsuperadmin.get('responsable').value=='user'">Code banque
          <input type="text" formControlName="banque" >
        </label>
         <label style="max-width: 50%;"><div *ngIf="submitted && fsuperadmin.clientcode.errors" class="invalid">
          <div *ngIf="fsuperadmin.clientcode.errors.required">Veuillez générer votre code client</div>
      </div>Code Client:<div style="display: flex;"><input class="input-field" style="background-color: white;color:black" type="text" id="clientcode" [ngClass]="{ 'is-invalid': submitted && fsuperadmin.clientcode.errors }"formControlName="clientcode" readonly="true"></div></label>
        
     <!--<label><div style="display: flex;"><span style="flex: 0.5">Indicatif:</span><span style="flex: 1">Mobile:</span><span style="flex:1">Confirmer mobile:</span></div>
          <div style="display: flex;"><div *ngIf="submitted && fsuperadmin.indicatif.errors" style="flex: 0.5" class="invalid">
          <div *ngIf="fsuperadmin.indicatif.errors.required">Indicatif Mobile Obligatoire </div>
          <div *ngIf="fsuperadmin.indicatif.errors.pattern">Veuillez saisir un indicatif valide</div> 
      </div>
      <div *ngIf="submitted && fsuperadmin.mobile.errors" style="flex:1"class="invalid">
        <div *ngIf="fsuperadmin.mobile.errors.required">Numéro Mobile Obligatoire</div>
        <div *ngIf="fsuperadmin.mobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
      </div>
      <div *ngIf="submitted && fsuperadmin.confirmmobile.errors" class="invalid">
      <div *ngIf="fsuperadmin.confirmmobile.errors.required">Numéro Mobile Obligatoire</div>
      <div *ngIf="fsuperadmin.confirmmobile.errors.mustMatch">Les numéros mobiles ne sont pas identiques</div>
      <div *ngIf="fsuperadmin.confirmmobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
      
      </div> 
      </div>
      <div style="display: flex"><input class="input-field" style="flex: 0.5"type="text" placeholder="Indicatif pays" id="indicatif" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.indicatif.errors }"formControlName="indicatif" style="width: 100px;">
      <input class="input-field" style="flex:1"type="text" placeholder="Numéro Mobile" id="mobile" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.mobile.errors }"formControlName="mobile"> 
      <input class="input-field" style="flex:1"type="text" placeholder="Confirmez Mobile" id="confirmmobile" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.confirmmobile.errors }"formControlName="confirmmobile">
      </div>   
      </label>--> 
      
      <label><div style="display: flex;"><span style="flex: 1">Email:</span><span style="flex: 1">Confirmer Email:</span></div>
      <div style="display: flex;"><div *ngIf="submitted && fsuperadmin.email.errors" class="invalid"style="flex: 1">
        <div *ngIf="fsuperadmin.email.errors.required">Email Obligatoire</div>
        <div *ngIf="fsuperadmin.email.errors.email">Adresse Email non valides</div>
      </div>
      <div *ngIf="submitted && fsuperadmin.confirmemail.errors" class="invalid"style="flex: 1">
      <div *ngIf="fsuperadmin.confirmemail.errors.required">Email Obligatoire</div>
      <div *ngIf="fsuperadmin.confirmemail.errors.email">Adresse Email non valides</div>
      <div *ngIf="fsuperadmin.confirmemail.errors.mustMatch">Les Emails  ne sont pas identiques</div>
      </div></div>
      <div style="display: flex"><input class="input-field" type="email" placeholder="Entrez Votre Email" id="email" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.email.errors }"formControlName="email">
      <input class="input-field" type="email" placeholder="Confirmez Votre Email" id="confirmemail" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.confirmemail.errors }"formControlName="confirmemail" required></div>
      </label>
      
      <label><div style="display: flex;"><span style="flex: 1">Mot de passe:</span><span style="flex: 1">Confirmer Mot de passe:</span></div>
      <div style="display: flex;"> <div *ngIf="submitted && fsuperadmin.password.errors" class="invalid"style="flex: 1">
        <div *ngIf="fsuperadmin.password.errors.required">Mot de passe Obligatoire</div> 
      </div>
      <div *ngIf="submitted && fsuperadmin.confirmpassword.errors" class="invalid"style="flex: 1">
      <div *ngIf="fsuperadmin.confirmpassword.errors.required">Mot de passe Obligatoire</div>
      <div *ngIf="fsuperadmin.confirmpassword.errors.mustMatch">Les Mot de passe  ne sont pas identiques</div>
      </div></div>
      <div style="display: flex">
      <input class="input-field" [type]="fieldTextType ? 'text' : 'password'" placeholder="Entrez Votre Mot De Passe" id="password" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.password.errors }"formControlName="password" required>
      <span class="input-field">
        <i
          class="fa"
          [ngClass]="{
            'fa-eye-slash': !fieldTextType,
            'fa-eye': fieldTextType
          }"
          (click)="toggleFieldTextType()"
        ></i>
      </span>
      <input class="input-field" [type]="repeatFieldTextType ? 'text' : 'password'" placeholder="Confirmer Votre Mot De Passe" id="confirmpassword" 
      [ngClass]="{ 'is-invalid': submitted && fsuperadmin.confirmpassword.errors }"formControlName="confirmpassword" required>
      <span class="input-field">
        <i
          class="fa"
          [ngClass]="{
            'fa-eye-slash': !repeatFieldTextType,
            'fa-eye': repeatFieldTextType
          }"
          (click)="togglerepeatFieldTextType()"
        ></i>
      </span>
      </div>
      </label>
    </fieldset>
    <button class="btn btn-success" (click)="onSignupsuperadmin()">Créer Utilisateur</button>
    <button class="btn btn-primary" (click)="onResetsuperadmin()">Réinitialiser</button>  
  </form>
  <form [formGroup]="signupFormadminbanque"*ngIf="role == 'adminbanque'">
    <fieldset>
      <div style="display: flex;">
        <label>
          <div *ngIf="submitted && fadminbanque.usertype.errors" class="invalid">
          <div *ngIf="fadminbanque.usertype.errors.required">Type Utilisateur est obligatoire</div>
      </div>Type Utilisateur:
      <select  class="input-field"  placeholder="Entrer Votre Role Utilisateur"id="role" formControlName="usertype" name="usertype"
      [ngClass]="{ 'is-invalid': submitted && fadminbanque.usertype.errors }" >
      <option value="Clientpor">Client Porteur</option>
      <option value="Clientcomm">Client commerçant</option>
      <option value="Agence">agence</option>
      <option value="Metier">Métier</option>
      </select>
    </label>
        <label>
          <div *ngIf="submitted && fadminbanque.lastname.errors" class="invalid">
          <div *ngIf="fadminbanque.lastname.errors.required">Nom Obligatoire</div>
      </div><span>Nom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Nom" id="lastname" formControlName="lastname" name="lastname" [ngClass]="{ 'is-invalid': submitted && fadminbanque.lastname.errors }"></span>
  </label>
    
        <label>
          <div *ngIf="submitted && fadminbanque.firstname.errors" class="invalid">
          <div *ngIf="fadminbanque.firstname.errors.required">Prénom Obligatoire</div>
      </div><span>Prénom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Prenom" id="firstname" formControlName="firstname" name="firstname" [ngClass]="{ 'is-invalid': submitted && fadminbanque.firstname.errors }"></span>
    </label>
        </div>
      <!--<label for="">Code banque
          <input type="text" formControlName="banque" readonly="true">
        </label>-->  
        <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Agence'">indicatif Agence
          <input type="text" formControlName="indicatifagence" >
        </label>
   <!--<label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientcomm'">terminal
          <input type="text" formControlName="terminal" >
        </label>
        <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientpor'">carte
          <input type="text" formControlName="carte" >
        </label>
        <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientpor'">RIB
          <input type="text" formControlName="compte" >
        </label>
         <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientcomm'">affiliation
          <input type="text" formControlName="affiliation" >
        </label>-->     
          <label style="max-width: 50%;"><div *ngIf="submitted && fadminbanque.clientcode.errors" class="invalid">
            <div *ngIf="fadminbanque.clientcode.errors.required">Veuillez générer votre code client</div>
        </div>Code Client:<div style="display: flex;"><input class="input-field" style="background-color: white;color:black" type="text" id="clientcode" [ngClass]="{ 'is-invalid': submitted && fadminbanque.clientcode.errors }"formControlName="clientcode" readonly="true"></div></label>
          
       <!-- <label><div style="display: flex;"><span style="flex: 0.5">Indicatif:</span><span style="flex: 1">Mobile:</span><span style="flex:1">Confirmer mobile:</span></div>
            <div style="display: flex;"><div *ngIf="submitted && fadminbanque.indicatif.errors" style="flex: 0.5" class="invalid">
            <div *ngIf="fadminbanque.indicatif.errors.required">Indicatif Mobile Obligatoire </div>
            <div *ngIf="fadminbanque.indicatif.errors.pattern">Veuillez saisir un indicatif valide</div> 
        </div>
        <div *ngIf="submitted && fadminbanque.mobile.errors" style="flex:1"class="invalid">
          <div *ngIf="fadminbanque.mobile.errors.required">Numéro Mobile Obligatoire</div>
          <div *ngIf="fadminbanque.mobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
        </div>
        <div *ngIf="submitted && fadminbanque.confirmmobile.errors" class="invalid">
        <div *ngIf="fadminbanque.confirmmobile.errors.required">Numéro Mobile Obligatoire</div>
        <div *ngIf="fadminbanque.confirmmobile.errors.mustMatch">Les numéros mobiles ne sont pas identiques</div>
        <div *ngIf="fadminbanque.confirmmobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
        
        </div> 
        </div>
        <div style="display: flex"><input class="input-field" style="flex: 0.5"type="text" placeholder="Indicatif pays" id="indicatif" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.indicatif.errors }"formControlName="indicatif" style="width: 100px;">
        <input class="input-field" style="flex:1"type="text" placeholder="Numéro Mobile" id="mobile" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.mobile.errors }"formControlName="mobile"> 
        <input class="input-field" style="flex:1"type="text" placeholder="Confirmez Mobile" id="confirmmobile" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.confirmmobile.errors }"formControlName="confirmmobile">
        </div> 
        </label>-->  
        
        <label><div style="display: flex;"><span style="flex: 1">Email:</span><span style="flex: 1">Confirmer Email:</span></div>
        <div style="display: flex;"><div *ngIf="submitted && fadminbanque.email.errors" class="invalid"style="flex: 1">
          <div *ngIf="fadminbanque.email.errors.required">Email Obligatoire</div>
          <div *ngIf="fadminbanque.email.errors.email">Adresse Email non valides</div>
        </div>
        <div *ngIf="submitted && fadminbanque.confirmemail.errors" class="invalid"style="flex: 1">
        <div *ngIf="fadminbanque.confirmemail.errors.required">Email Obligatoire</div>
        <div *ngIf="fadminbanque.confirmemail.errors.email">Adresse Email non valides</div>
        <div *ngIf="fadminbanque.confirmemail.errors.mustMatch">Les Emails  ne sont pas identiques</div>
        </div></div>
        <div style="display: flex"><input class="input-field" type="email" placeholder="Entrez Votre Email" id="email" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.email.errors }"formControlName="email">
        <input class="input-field" type="email" placeholder="Confirmez Votre Email" id="confirmemail" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.confirmemail.errors }"formControlName="confirmemail" required></div>
        </label>
        
        <label><div style="display: flex;"><span style="flex: 1">Mot de passe:</span><span style="flex: 1">Confirmer Mot de passe:</span></div>
        <div style="display: flex;"> <div *ngIf="submitted && fadminbanque.password.errors" class="invalid"style="flex: 1">
          <div *ngIf="fadminbanque.password.errors.required">Mot de passe Obligatoire</div> 
        </div>
        <div *ngIf="submitted && fadminbanque.confirmpassword.errors" class="invalid"style="flex: 1">
        <div *ngIf="fadminbanque.confirmpassword.errors.required">Mot de passe Obligatoire</div>
        <div *ngIf="fadminbanque.confirmpassword.errors.mustMatch">Les Mot de passe  ne sont pas identiques</div>
        </div></div>
        <div style="display: flex">
        <input class="input-field" [type]="fieldTextType ? 'text' : 'password'" placeholder="Entrez Votre Mot De Passe" id="password" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.password.errors }"formControlName="password" required>
        <span class="input-field">
          <i
            class="fa"
            [ngClass]="{
              'fa-eye-slash': !fieldTextType,
              'fa-eye': fieldTextType
            }"
            (click)="toggleFieldTextType()"
          ></i>
        </span>
        <input class="input-field" [type]="repeatFieldTextType ? 'text' : 'password'" placeholder="Confirmer Votre Mot De Passe" id="confirmpassword" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.confirmpassword.errors }"formControlName="confirmpassword" required>
        <span class="input-field">
          <i
            class="fa"
            [ngClass]="{
              'fa-eye-slash': !repeatFieldTextType,
              'fa-eye': repeatFieldTextType
            }"
            (click)="togglerepeatFieldTextType()"
          ></i>
        </span>
        </div>
        </label>
      </fieldset>
      <button class="btn btn-success" (click)="onSignupadminbanque()">Créer Utilisateur</button>
      <button class="btn btn-primary"(click)="onResetadminbanque()">Réinitialiser</button>  
  </form>
  <form [formGroup]="signupFormadmincomite"*ngIf="role == 'admincomite'">
    <fieldset>
      <div style="display: flex;">
        <label>
          <div *ngIf="submitted && fadmincomite.lastname.errors" class="invalid">
          <div *ngIf="fadmincomite.lastname.errors.required">Nom Obligatoire</div>
      </div><span>Nom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Nom" id="lastname" formControlName="lastname" name="lastname" [ngClass]="{ 'is-invalid': submitted && fadmincomite.lastname.errors }"></span>
  </label>
    
        <label>
          <div *ngIf="submitted && fadmincomite.firstname.errors" class="invalid">
          <div *ngIf="fadmincomite.firstname.errors.required">Prénom Obligatoire</div>
      </div><span>Prénom Utilisateur:
        <input class="input-field" type="text" placeholder="Entrer Votre Prenom" id="firstname" formControlName="firstname" name="firstname" [ngClass]="{ 'is-invalid': submitted && fadmincomite.firstname.errors }"></span>
    </label>
        </div>

        <label style="max-width: 50%;"><div *ngIf="submitted && fadmincomite.banque.errors" class="invalid">
          <div *ngIf="fadmincomite.banque.errors.required">Veuillez saisir le code banque</div>
      </div>Code banque:<div style="display: flex;"><input class="input-field" style="background-color: white;color:black" type="text" id="clientcode" [ngClass]="{ 'is-invalid': submitted && fadmincomite.banque.errors }"formControlName="banque"></div></label>

   <!--<label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientcomm'">terminal
          <input type="text" formControlName="terminal" >
        </label>
        <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientpor'">carte
          <input type="text" formControlName="carte" >
        </label>
        <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientpor'">RIB
          <input type="text" formControlName="compte" >
        </label>
         <label for="" *ngIf="signupFormadminbanque.get('usertype').value=='Clientcomm'">affiliation
          <input type="text" formControlName="affiliation" >
        </label>-->     
          <label style="max-width: 50%;"><div *ngIf="submitted && fadmincomite.clientcode.errors" class="invalid">
            <div *ngIf="fadmincomite.clientcode.errors.required">Veuillez générer votre code client</div>
        </div>Code Client:<div style="display: flex;"><input class="input-field" style="background-color: white;color:black" type="text" id="clientcode" [ngClass]="{ 'is-invalid': submitted && fadmincomite.clientcode.errors }"formControlName="clientcode" readonly="true"></div></label>
          
       <!-- <label><div style="display: flex;"><span style="flex: 0.5">Indicatif:</span><span style="flex: 1">Mobile:</span><span style="flex:1">Confirmer mobile:</span></div>
            <div style="display: flex;"><div *ngIf="submitted && fadminbanque.indicatif.errors" style="flex: 0.5" class="invalid">
            <div *ngIf="fadminbanque.indicatif.errors.required">Indicatif Mobile Obligatoire </div>
            <div *ngIf="fadminbanque.indicatif.errors.pattern">Veuillez saisir un indicatif valide</div> 
        </div>
        <div *ngIf="submitted && fadminbanque.mobile.errors" style="flex:1"class="invalid">
          <div *ngIf="fadminbanque.mobile.errors.required">Numéro Mobile Obligatoire</div>
          <div *ngIf="fadminbanque.mobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
        </div>
        <div *ngIf="submitted && fadminbanque.confirmmobile.errors" class="invalid">
        <div *ngIf="fadminbanque.confirmmobile.errors.required">Numéro Mobile Obligatoire</div>
        <div *ngIf="fadminbanque.confirmmobile.errors.mustMatch">Les numéros mobiles ne sont pas identiques</div>
        <div *ngIf="fadminbanque.confirmmobile.errors.pattern">Veuillez saisir un numéro mobile valide</div>
        
        </div> 
        </div>
        <div style="display: flex"><input class="input-field" style="flex: 0.5"type="text" placeholder="Indicatif pays" id="indicatif" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.indicatif.errors }"formControlName="indicatif" style="width: 100px;">
        <input class="input-field" style="flex:1"type="text" placeholder="Numéro Mobile" id="mobile" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.mobile.errors }"formControlName="mobile"> 
        <input class="input-field" style="flex:1"type="text" placeholder="Confirmez Mobile" id="confirmmobile" 
        [ngClass]="{ 'is-invalid': submitted && fadminbanque.confirmmobile.errors }"formControlName="confirmmobile">
        </div> 
        </label>-->  
        
        <label><div style="display: flex;"><span style="flex: 1">Email:</span><span style="flex: 1">Confirmer Email:</span></div>
        <div style="display: flex;"><div *ngIf="submitted && fadmincomite.email.errors" class="invalid"style="flex: 1">
          <div *ngIf="fadmincomite.email.errors.required">Email Obligatoire</div>
          <div *ngIf="fadmincomite.email.errors.email">Adresse Email non valides</div>
        </div>
        <div *ngIf="submitted && fadmincomite.confirmemail.errors" class="invalid"style="flex: 1">
        <div *ngIf="fadmincomite.confirmemail.errors.required">Email Obligatoire</div>
        <div *ngIf="fadmincomite.confirmemail.errors.email">Adresse Email non valides</div>
        <div *ngIf="fadmincomite.confirmemail.errors.mustMatch">Les Emails  ne sont pas identiques</div>
        </div></div>
        <div style="display: flex"><input class="input-field" type="email" placeholder="Entrez Votre Email" id="email" 
        [ngClass]="{ 'is-invalid': submitted && fadmincomite.email.errors }"formControlName="email">
        <input class="input-field" type="email" placeholder="Confirmez Votre Email" id="confirmemail" 
        [ngClass]="{ 'is-invalid': submitted && fadmincomite.confirmemail.errors }"formControlName="confirmemail" required></div>
        </label>
        
        <label><div style="display: flex;"><span style="flex: 1">Mot de passe:</span><span style="flex: 1">Confirmer Mot de passe:</span></div>
        <div style="display: flex;"> <div *ngIf="submitted && fadmincomite.password.errors" class="invalid"style="flex: 1">
          <div *ngIf="fadmincomite.password.errors.required">Mot de passe Obligatoire</div> 
        </div>
        <div *ngIf="submitted && fadmincomite.confirmpassword.errors" class="invalid"style="flex: 1">
        <div *ngIf="fadmincomite.confirmpassword.errors.required">Mot de passe Obligatoire</div>
        <div *ngIf="fadmincomite.confirmpassword.errors.mustMatch">Les Mot de passe  ne sont pas identiques</div>
        </div></div>
        <div style="display: flex">
        <input class="input-field" [type]="fieldTextType ? 'text' : 'password'" placeholder="Entrez Votre Mot De Passe" id="password" 
        [ngClass]="{ 'is-invalid': submitted && fadmincomite.password.errors }"formControlName="password" required>
        <span class="input-field">
          <i
            class="fa"
            [ngClass]="{
              'fa-eye-slash': !fieldTextType,
              'fa-eye': fieldTextType
            }"
            (click)="toggleFieldTextType()"
          ></i>
        </span>
        <input class="input-field" [type]="repeatFieldTextType ? 'text' : 'password'" placeholder="Confirmer Votre Mot De Passe" id="confirmpassword" 
        [ngClass]="{ 'is-invalid': submitted && fadmincomite.confirmpassword.errors }"formControlName="confirmpassword" required>
        <span class="input-field">
          <i
            class="fa"
            [ngClass]="{
              'fa-eye-slash': !repeatFieldTextType,
              'fa-eye': repeatFieldTextType
            }"
            (click)="togglerepeatFieldTextType()"
          ></i>
        </span>
        </div>
        </label>
      </fieldset>
      <button class="btn btn-success" (click)="onSignupadmincomite()">Créer Utilisateur</button>
      <button class="btn btn-primary"(click)="onResetadmincomite()">Réinitialiser</button>  
  </form>
  </div>
</div>
